<template>
  <b-modal
    id="delete-modal"
    :visible="visible"
    @hide="$emit('close')"
    hide-footer
    centered
  >
    <div class="d-flex">
      <div class="trash-wrap">
        <i class="fa fa-triangle-exclamation" />
      </div>
      <div>
        <h6 class="">Are you sure you want to delete ?</h6>
        <p class="light-txt">
          The action can't be undone.this will be permanently deleted and
          removed from our records. If you are sure , please confirm your
          decision.
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3 gap-2">
      <b-button variant="secondary" @click="$emit('close')">Close</b-button>
      <b-button variant="primary" class="univ-btn univ-delete m-0 p-0 w-fit" @click="$emit('delete')"
        >Delete</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "Delete",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
#delete-modal .modal-body {
  padding-top: 0 !important;
}
.trash-wrap {
  background-color: #fbe9e9;
  border-radius: 50px;
  height: fit-content;
  padding: 0.7rem 0.8rem;
  margin-right: 1rem;
}

.trash-wrap i {
  color: #c70606;
  font-size: 18px;
}
.univ-delete{
  background:#c70606;
}
.univ-delete:hover ,.univ-delete:focus,.univ-delete:active{
  background:#9f0404;
}
</style>
